export const WO_STATUS_META = {
    draft: { label: "Draft", color: "default" },
    released: { label: "Released", color: "info" },
    in_progress: { label: "In Progress", color: "warning" },
    on_hold: { label: "On Hold", color: "secondary" },
    complete: { label: "Complete", color: "success" },
    cancelled: { label: "Cancelled", color: "error" },
};

export const TRAVELER_STATUS_META = {
    pending: { label: "Pending", color: "default" },
    in_progress: { label: "In Progress", color: "warning" },
    submitted: { label: "Submitted", color: "info" },
    approved: { label: "Approved", color: "success" },
    failed: { label: "Failed", color: "error" },
    on_hold: { label: "On Hold", color: "secondary" },
};
